import React from "react";
import { ProducerUploadContentTemplate } from "themes/application/producer/pages";
import { ProducerUploadContentViewStore } from "application/producer/stores";
import { setCurrentView } from "mrb/core";

@setCurrentView(
    (rootStore, componentProps) => new ProducerUploadContentViewStore(rootStore, componentProps),
    "producerUploadContentViewStore"
)
class ProducerUploadContent extends React.Component {
    render() {
        return <ProducerUploadContentTemplate {...this.props} />;
    }
}

export default ProducerUploadContent;
